var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "container-external-api" }
    },
    [
      _c("h3", { staticClass: "modal-title" }, [
        _vm._v(" " + _vm._s(_vm.fieldDetail ? "EDIT FIELD" : "ADD FIELD") + " ")
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: _vm.isHaveConfig ? "6" : "12" } },
            [
              _c("h4", [_vm._v("Properties")]),
              _vm._v(" "),
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.type.$error } },
                [
                  _c("label", [_vm._v(" Type ")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      options:
                        _vm.type === "table_group"
                          ? _vm.listTypeTable
                          : _vm.listType,
                      placeholder: "Select Type",
                      "value-format": "object",
                      label: "text"
                    },
                    model: {
                      value: _vm.dataSetup.type,
                      callback: function($$v) {
                        _vm.$set(_vm.dataSetup, "type", $$v)
                      },
                      expression: "dataSetup.type"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form",
                        {
                          class: { "error-input": _vm.$v.dataSetup.key.$error }
                        },
                        [
                          _c("label", [_vm._v(" Key ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: { placeholder: "Enter key" },
                            model: {
                              value: _vm.dataSetup.key,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "key", $$v)
                              },
                              expression: "dataSetup.key"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.isDisable.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Disable ")]),
                          _vm._v(" "),
                          _c("j-toggle", {
                            attrs: { disabled: _vm.isDisabledField },
                            model: {
                              value: _vm.dataSetup.isDisable,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "isDisable", $$v)
                              },
                              expression: "dataSetup.isDisable"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.isMandatory.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Mandatory ")]),
                          _vm._v(" "),
                          _c("j-toggle", {
                            model: {
                              value: _vm.dataSetup.isMandatory,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "isMandatory", $$v)
                              },
                              expression: "dataSetup.isMandatory"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.name.$error } },
                [
                  _c("label", [_vm._v(" Name ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: { placeholder: "Enter field name" },
                    model: {
                      value: _vm.dataSetup.name,
                      callback: function($$v) {
                        _vm.$set(_vm.dataSetup, "name", $$v)
                      },
                      expression: "dataSetup.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                {
                  class: { "error-input": _vm.$v.dataSetup.placeholder.$error }
                },
                [
                  _c("label", [_vm._v(" Placeholder ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: { placeholder: "Enter field placeholder" },
                    model: {
                      value: _vm.dataSetup.placeholder,
                      callback: function($$v) {
                        _vm.$set(_vm.dataSetup, "placeholder", $$v)
                      },
                      expression: "dataSetup.placeholder"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.grid.$error } },
                [
                  _c("label", [_vm._v(" Grid ")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      options: _vm.listGrid,
                      placeholder: "Select Grid",
                      disabled: _vm.isNoGrid,
                      label: "text"
                    },
                    model: {
                      value: _vm.dataSetup.grid,
                      callback: function($$v) {
                        _vm.$set(_vm.dataSetup, "grid", $$v)
                      },
                      expression: "dataSetup.grid"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.dataSetup.type &&
                        _vm.dataSetup.type.id !== "separator" &&
                          _vm.dataSetup.type.id !== "custom_html",
                      expression:
                        "dataSetup.type && (dataSetup.type.id !== 'separator' && dataSetup.type.id !== 'custom_html')"
                    }
                  ]
                },
                [
                  _c("h4", [_vm._v("Parse Value To")]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      class: { "error-input": _vm.$v.dataSetup.variable.$error }
                    },
                    [
                      _c("label", [_vm._v(" Variable ")]),
                      _vm._v(" "),
                      _vm.isExternal
                        ? _c("j-input", {
                            attrs: { placeholder: "Enter source" },
                            model: {
                              value: _vm.dataSetup.variable,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "variable", $$v)
                              },
                              expression: "dataSetup.variable"
                            }
                          })
                        : _c("j-single-select", {
                            attrs: {
                              options: _vm.variableOptions,
                              placeholder: "Select Variable",
                              "value-format": "object",
                              label: "label"
                            },
                            model: {
                              value: _vm.dataSetup.variable,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "variable", $$v)
                              },
                              expression: "dataSetup.variable"
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isHaveConfig
            ? _c("b-col", { attrs: { md: "6" } }, [
                _vm.dataSetup.type.id === "location"
                  ? _c(
                      "div",
                      [
                        _c("h4", [_vm._v("Config")]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.locationType.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Location Type ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.listLocationType,
                                placeholder: "Select Location Type",
                                label: "text"
                              },
                              model: {
                                value: _vm.dataSetup.locationType,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "locationType", $$v)
                                },
                                expression: "dataSetup.locationType"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "single_selection" ||
                _vm.dataSetup.type.id === "multiple_selection" ||
                _vm.dataSetup.type.id === "photo" ||
                _vm.dataSetup.type.id === "attachment" ||
                _vm.dataSetup.type.id === "radio" ||
                _vm.dataSetup.type.id === "checkbox"
                  ? _c(
                      "div",
                      [
                        _c("h4", [_vm._v("Options")]),
                        _vm._v(" "),
                        _vm._l(_vm.dataSetup.options, function(
                          itemOptions,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "10" } },
                                    [
                                      _c(
                                        "b-form",
                                        {
                                          class: {
                                            "error-input":
                                              _vm.$v.dataSetup.options.$each[
                                                index
                                              ].$error
                                          }
                                        },
                                        [
                                          _c("j-input", {
                                            attrs: {
                                              placeholder: "Enter options"
                                            },
                                            model: {
                                              value:
                                                _vm.dataSetup.options[index],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup.options,
                                                  index,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataSetup.options[index]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__l--1 m__t--5",
                                      attrs: { md: "2" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-trash cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteOptions(index)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-add-column m__b--15",
                                  on: { click: _vm.addoptions }
                                },
                                [
                                  _vm._v(
                                    "\n              + Add options\n            "
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "attachment" ||
                _vm.dataSetup.type.id === "multiple_attachment_dynamic" ||
                _vm.dataSetup.type.id === "single_attachment"
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.acceptedFileType.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Accepted File Type ")]),
                            _vm._v(" "),
                            _c("j-multi-select", {
                              attrs: {
                                options: _vm.list_accepted_file_type,
                                placeholder: "Select Accepted File Type"
                              },
                              model: {
                                value: _vm.$v.dataSetup.acceptedFileType.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.acceptedFileType,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.dataSetup.acceptedFileType.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input": _vm.$v.dataSetup.isUseCamera.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Use Camera ")]),
                            _vm._v(" "),
                            _c("j-toggle", {
                              model: {
                                value: _vm.dataSetup.isUseCamera,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "isUseCamera", $$v)
                                },
                                expression: "dataSetup.isUseCamera"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.dataSetup.isUseCamera
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.sourceCamera.$error
                                    }
                                  },
                                  [
                                    _c("label", [_vm._v(" Source ")]),
                                    _vm._v(" "),
                                    _c("b-form-radio-group", {
                                      staticClass: "jFormGroup",
                                      attrs: {
                                        options: _vm.list_source_camera,
                                        stacked: true
                                      },
                                      model: {
                                        value:
                                          _vm.$v.dataSetup.sourceCamera.$model,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.$v.dataSetup.sourceCamera,
                                            "$model",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "$v.dataSetup.sourceCamera.$model"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.chooseCamera.$error
                                    }
                                  },
                                  [
                                    _c("label", [_vm._v(" Choose Camera ")]),
                                    _vm._v(" "),
                                    _c("j-single-select", {
                                      attrs: {
                                        options: _vm.list_choose_camera,
                                        placeholder: "Choose Camera"
                                      },
                                      model: {
                                        value:
                                          _vm.$v.dataSetup.chooseCamera.$model,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.$v.dataSetup.chooseCamera,
                                            "$model",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "$v.dataSetup.chooseCamera.$model"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "relation_record" ||
                _vm.dataSetup.type.id === "multiple_relation_record"
                  ? _c(
                      "div",
                      [
                        _c("h4", [_vm._v("Source Data")]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.sourceData.tableGroup.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Table Group ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.tableGroupOptions,
                                placeholder: "Select Table Group",
                                "value-format": "object",
                                label: "name"
                              },
                              model: {
                                value:
                                  _vm.$v.dataSetup.sourceData.tableGroup.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.sourceData.tableGroup,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.dataSetup.sourceData.tableGroup.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.sourceData.form.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Table ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                disabled: !_vm.dataSetup.sourceData.tableGroup,
                                options: _vm.tableOptions,
                                placeholder: "Select Table",
                                "value-format": "object",
                                label: "name"
                              },
                              model: {
                                value: _vm.$v.dataSetup.sourceData.form.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.sourceData.form,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.dataSetup.sourceData.form.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.sourceData.showData.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Show Data Option ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.list_field,
                                label: "name",
                                placeholder: "Select Variable"
                              },
                              model: {
                                value:
                                  _vm.$v.dataSetup.sourceData.showData.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.sourceData.showData,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.dataSetup.sourceData.showData.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.sourceData.searchData.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Search Data Option ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.list_field,
                                label: "name",
                                placeholder: "Select Variable"
                              },
                              model: {
                                value:
                                  _vm.$v.dataSetup.sourceData.searchData.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.sourceData.searchData,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.dataSetup.sourceData.searchData.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.sourceData.setValue.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Set Value Selected ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.list_field,
                                label: "name",
                                placeholder: "Select Variable"
                              },
                              model: {
                                value:
                                  _vm.$v.dataSetup.sourceData.setValue.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.sourceData.setValue,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.dataSetup.sourceData.setValue.$model"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "relation_record_external_api" ||
                _vm.dataSetup.type.id ===
                  "multiple_relation_record_external_api"
                  ? _c(
                      "div",
                      [
                        _c("h4", [_vm._v("Source Data")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "external-ui" }, [
                          _vm._v("\n          External API "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "font-blue cursor-pointer",
                              attrs: { id: "externalApiAdd" }
                            },
                            [_vm._v("\n            Config\n          ")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.sourceExternalVariable.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Show Data Option ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: { placeholder: "Enter variable" },
                              model: {
                                value: _vm.dataSetup.sourceExternalVariable,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "sourceExternalVariable",
                                    $$v
                                  )
                                },
                                expression: "dataSetup.sourceExternalVariable"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.sourceExternalSetValue.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Set Value Selected ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.list_field_external,
                                placeholder: "Select Variable"
                              },
                              model: {
                                value:
                                  _vm.$v.dataSetup.sourceExternalSetValue
                                    .$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.sourceExternalSetValue,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.dataSetup.sourceExternalSetValue.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-popover",
                          {
                            ref: "popoverExternalApi",
                            attrs: {
                              show: _vm.popoverExternalApiShow,
                              target: "externalApiAdd",
                              container: "container-external-api",
                              triggers: "click",
                              placement: "left"
                            },
                            on: {
                              "update:show": function($event) {
                                _vm.popoverExternalApiShow = $event
                              }
                            }
                          },
                          [
                            _c("j-external-api-field", {
                              attrs: {
                                "data-edit": _vm.dataSetup.sourceExternal
                              },
                              on: {
                                "submit-data": _vm.submitExternalUrl,
                                "close-modal": _vm.closeModalExternalUrl
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "single_tags_selection" ||
                _vm.dataSetup.type.id === "multiple_tags_selection"
                  ? _c(
                      "div",
                      [
                        _c("h4", { staticClass: "p__b--10" }, [
                          _vm._v("Options")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dataSetup.tags, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "container-group__item"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "item__counter-group" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(index + 1) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "item__remove cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteTags(index)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash fa-2x" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                [
                                  _c("label", [_vm._v(" Name ")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: { placeholder: "Enter tags name" },
                                    model: {
                                      value: item.name,
                                      callback: function($$v) {
                                        _vm.$set(item, "name", $$v)
                                      },
                                      expression: "item.name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c("j-color-picker", {
                                        attrs: {
                                          color: item.background,
                                          label: "Background",
                                          picker: "chrome"
                                        },
                                        model: {
                                          value: item.background,
                                          callback: function($$v) {
                                            _vm.$set(item, "background", $$v)
                                          },
                                          expression: "item.background"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c("j-color-picker", {
                                        attrs: {
                                          color: item.font_color,
                                          label: "Font Color",
                                          picker: "chrome"
                                        },
                                        model: {
                                          value: item.font_color,
                                          callback: function($$v) {
                                            _vm.$set(item, "font_color", $$v)
                                          },
                                          expression: "item.font_color"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-add-column m__b--15",
                                  on: { click: _vm.addTags }
                                },
                                [
                                  _vm._v(
                                    "\n              + Add options\n            "
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      2
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "float-right" },
        [
          _c(
            "b-button",
            { staticClass: "btn m__r--5", on: { click: _vm.closeModal } },
            [_vm._v("\n      Close\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            { staticClass: "btn blue", on: { click: _vm.submitForm } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.fieldDetail ? "Update" : "Add") +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-361fca10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361fca10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager/menu/jColumnEditFill.vue
// module id = null
// module chunks = 